// Native HTML5 drag-and-drop payload shared between client-folder drag
// sources (FoldersList table rows, FolderKanban cards) and drop targets
// (ActiveFolderCard) — keeps the MIME type + JSON (de)serialization in one
// place so all of them stay in sync.
export const FOLDER_DRAG_TYPE = 'application/x-koob-folder';

// Call from a drag source's onDragStart.
export function setFolderDragData(dataTransfer, folder) {
  dataTransfer.setData(FOLDER_DRAG_TYPE, JSON.stringify(folder));
  dataTransfer.effectAllowed = 'copy';
}

// Call from onDragEnter/onDragOver to check compatibility before calling
// preventDefault() — dataTransfer.getData() is only readable on drop, but
// .types is readable throughout the drag.
export function isFolderDragEvent(dataTransfer) {
  return Array.from(dataTransfer?.types ?? []).includes(FOLDER_DRAG_TYPE);
}

// Call from a drop target's onDrop; returns null if the payload is missing
// or malformed.
export function getFolderDragData(dataTransfer) {
  try {
    const raw = dataTransfer.getData(FOLDER_DRAG_TYPE);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
